import React from 'react';
import theme from './BudgetItemPrice.module.scss';
import { BudgetItemDto, BudgetItemPriceType } from '@/types';
import { BuyerCurrencyDisplay } from '@/buyer/components/BuyerCurrencyDisplay';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Trans } from '@lingui/react/macro';
import { faFileSignature, faFileCheck } from '@fortawesome/pro-light-svg-icons';

interface BudgetItemPriceProps {
    budgetItem: BudgetItemDto;
    className?: string;
}

const BudgetItemPrice: React.FC<BudgetItemPriceProps> = ({ budgetItem, className }) => {
    if (budgetItem.hidePrice) {
        return null;
    }

    return (
        <div className={className}>
            <BuyerCurrencyDisplay value={budgetItem.totalPrice} />
            <div>
                {budgetItem.priceType === BudgetItemPriceType.Signed && (
                    <span className={theme.signed}>
                        <FontAwesomeIcon icon={faFileCheck} />
                        <Trans>Signed</Trans>
                    </span>
                )}

                {budgetItem.priceType === BudgetItemPriceType.Unsigned && (
                    <span className={theme.unsigned}>
                        <FontAwesomeIcon icon={faFileSignature} />
                        <Trans>Waiting for signature</Trans>
                    </span>
                )}

                {budgetItem.priceType === BudgetItemPriceType.Expired && (
                    <span className={theme.expired}>
                        <FontAwesomeIcon icon={faFileSignature} />
                        <Trans>Deadline expired</Trans>
                    </span>
                )}
            </div>
        </div>
    );
};

export default BudgetItemPrice;
